const PAGE_SIZE = 12;
const state = { type: PAGE_SIZE, category: PAGE_SIZE };
const currentFilter = { type: 'all', category: 'all' };

// collapse slashes & spaces into single hyphens, trim ends
function slugify(str) {
  return str.toLowerCase()
    .replace(/\//g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

document.addEventListener('DOMContentLoaded', () => {
  // 1) TOOLTIP BINDINGS
  const defsEl  = document.getElementById('knot-definitions');
  const tooltip = document.getElementById('custom-tooltip');
  if (defsEl && tooltip) {
    const knotDefs = JSON.parse(defsEl.dataset.knotDefinitions || '[]');
    document.querySelectorAll('#type-buttons .tab').forEach(btn => {
      const info = knotDefs.find(d => slugify(d.key) === btn.dataset.type);
      if (!info) return;
      const move = e => {
        tooltip.style.left = `${e.pageX + 10}px`;
        tooltip.style.top  = `${e.pageY + 10}px`;
      };
      btn.addEventListener('mouseenter', e => {
        btn.dataset.title = btn.title || '';
        btn.removeAttribute('title');
        tooltip.textContent   = info.definition;
        tooltip.style.display = 'block';
        move(e);
      });
      btn.addEventListener('mousemove', move);
      btn.addEventListener('mouseleave', () => {
        btn.setAttribute('title', btn.dataset.title || '');
        delete btn.dataset.title;
        tooltip.style.display = 'none';
      });
    });
  }

  // 2) SHOW/HIDE + PAGINATION
  function filterArticles(filterType, group) {
    currentFilter[group] = filterType;
    const fmt  = slugify(filterType);
    const grid = document.getElementById(`knot-database-${group}`);
    const tabs = document.getElementById(`${group}-buttons`).querySelectorAll('.tab');

    // first, mark cards by filter
    Array.from(grid.querySelectorAll('.article-wrapper')).forEach(card => {
      const match = fmt === 'all' || card.classList.contains(fmt);
      card.style.display = match ? '' : 'none';
    });

    // reset page count & apply pagination
    state[group] = PAGE_SIZE;
    updateViewMore(group);

    // update active tab
    tabs.forEach(btn => {
      const bt    = slugify(btn.dataset.type || '');
      const isAll = btn.classList.contains('all') && fmt === 'all';
      btn.classList.toggle('active', isAll || bt === fmt);
    });
  }

  function updateViewMore(group) {
    const fmt   = slugify(currentFilter[group]);
    const limit = state[group];
    const grid  = document.getElementById(`knot-database-${group}`);
    const btn   = document.getElementById(`viewMoreButton-${group}`);
    if (!grid || !btn) return;

    const cards = Array.from(grid.querySelectorAll('.article-wrapper'));
    let shown   = 0;
    let totalMatches = 0;

    cards.forEach(card => {
      if (fmt === 'all' || card.classList.contains(fmt)) {
        totalMatches++;
        if (shown < limit) {
          card.style.display = '';
          shown++;
        } else {
          card.style.display = 'none';
        }
      } else {
        card.style.display = 'none';
      }
    });

    // show button only if there are more to load
    btn.style.display = totalMatches > limit ? '' : 'none';
  }

  // wire up filter clicks & initial load
  ['type','category'].forEach(group => {
    const wrap = document.getElementById(`${group}-buttons`);
    wrap?.addEventListener('click', e => {
      const btn = e.target.closest('.tab[data-type]');
      if (!btn) return;
      e.preventDefault();
      filterArticles(btn.dataset.type, group);
    });
    // initial “All” load
    filterArticles('all', group);

    // wire view-more button
    document
      .getElementById(`viewMoreButton-${group}`)
      .addEventListener('click', () => {
        state[group] += PAGE_SIZE;
        updateViewMore(group);
      });
  });
});
